// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:_BRbNO */\n.dosjS{display:flex;flex-wrap:wrap;gap:var(--audio-spacing-8);justify-content:center}.GcALg{display:inline-flex}@media (min-width:1280px){.dosjS{align-content:flex-end;justify-content:flex-start}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags": "dosjS",
	"link": "GcALg"
};
export default ___CSS_LOADER_EXPORT___;
